import { render } from "./getAuthUrl.vue?vue&type=template&id=2b909b2b"
import script from "./getAuthUrl.vue?vue&type=script&lang=js"
export * from "./getAuthUrl.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__